<template>
  <router-link
    to="/"
    class="flex-shrink-0 flex items-center gap-2 sm:gap-3"
  >
    <!-- Logo for dark mode -->
    <img 
      v-if="isDark" 
      src="@/assets/DarkModeLogo.png" 
      alt="Logo" 
      :class="logoClasses"
    >
    <!-- Logo for light mode -->
    <img 
      v-else 
      src="@/assets/Logo.png" 
      alt="Logo" 
      :class="logoClasses"
    >
    <!-- Restaurant Name -->
    <div
      v-if="restaurant && showRestaurantName"
      :class="restaurantNameClasses"
    >
      <span class="font-semibold text-gray-900 dark:text-white truncate">
        {{ restaurant.name }}
      </span>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useTheme } from '@/composables/useTheme';
import { useRestaurant } from '@/composables/useRestaurant';

interface Props {
  size?: 'small' | 'medium' | 'large';
  showRestaurantName?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'medium',
  showRestaurantName: true
});

const { isDark } = useTheme();
const { restaurant } = useRestaurant();

const logoClasses = computed(() => {
  const baseClasses = 'w-auto cursor-pointer hover:opacity-80 transition-opacity';
  
  switch (props.size) {
    case 'small':
      return `${baseClasses} h-8`;
    case 'large':
      return `${baseClasses} h-12`;
    default:
      return `${baseClasses} h-8 sm:h-12`;
  }
});

const restaurantNameClasses = computed(() => {
  switch (props.size) {
    case 'small':
      return 'text-xs max-w-[120px]';
    case 'large':
      return 'text-base max-w-[200px]';
    default:
      return 'hidden md:block text-sm max-w-[160px]';
  }
});
</script>
